import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  public myAccount = new Subject();
  public data = this.myAccount.asObservable();
  public userData: any;


  public getLimit = new BehaviorSubject("");
  public privacyscore = new BehaviorSubject("");
  public securityscore = new BehaviorSubject("");
  public getSelectedLang = new BehaviorSubject("")
  constructor(private _apiService: ApiService,
    private _router: Router,
    private _service: ApiService,
    private _http: HttpClient,
  ) { }

  setUserData(data: any) {
    this.userData = data;
  }
  updateMyUserData(data: any) {
    this.myAccount.next(data);

  }
  sendOtpOnEmail(data: any) {
    try {
      var responseData: any
      this._service.postService(this._service.API_URL.emailGenerateOtp, data).subscribe((response: any) => {
        responseData = response;
        return response;

      })
    }
    catch (e) { }

  }

  verifyOTP(data: any) {
    let response: any
    this._service.postService(this._service.API_URL.signupOtpVerification, data).subscribe((response) => {
    })
    return response;

  }
  timer: any;
  durationMinutes: any;
  timeOver: any;

  timeObject: any[] = [];
  startTimerForFiveMinute(minute: number) {
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;
    const prefix = minute < 10 ? "0" : "";
    this.timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.durationMinutes = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
      if (seconds == 0) {
        this.timeOver = false;
        clearInterval(this.timer);
      }
      this.timeObject.push(this.timeOver)
      this.timeObject.push(this.durationMinutes);

    }, 1000);

    return this.timeObject;
  }
}
